import { HeadItemType, Table } from 'components/Table'

import * as S from './styles'
import { type LeadTimesUploadError } from 'services/leadTimes'

const headDataLeadTimes: HeadItemType[] = [
  { label: 'Material', columnName: 'material' },
  { label: 'Descrição', columnName: 'description' },
  { label: 'Tecnologia', columnName: 'technology' },
  { label: 'Erro', columnName: 'error' }
]

interface UploadSpreadsheetTableErrorProps {
  data: LeadTimesUploadError[]
}

export const UploadSpreadsheetTableError: React.FC<UploadSpreadsheetTableErrorProps> = ({
  data
}) => {
  if (!data || data.length === 0) {
    return null
  }

  const renderSummary = () => {
    const amount = data?.length ?? 0
    return amount > 1 ? `${amount} erros encontrados` : `${amount} erro encontrado`
  }

  const renderBody = () => {
    return data.map((item) => {
      const key = `${item.material}-${item.description}-${item.error}`

      return {
        id: `id-${key}`,
        content: [
          <span key={`Material-${key}`}>{item.material ?? '-'}</span>,
          <span key={`Description-${key}`}>{item.description ?? '-'}</span>,
          <span key={`Technology-${key}`}>{item.technology ?? '-'}</span>,
          <S.DataWrapError key={`Erro-${key}`}>
            <span>{item.error}</span>
          </S.DataWrapError>
        ]
      }
    })
  }

  const headData = headDataLeadTimes

  return (
    <S.Container>
      <S.Summary>{renderSummary()}</S.Summary>
      <Table headData={headData} bodyData={renderBody()} rowHeight={40} />
    </S.Container>
  )
}
